import { ChangeDetectionStrategy, Component, ElementRef, TemplateRef } from '@angular/core';

import { GasDynamicBaseComponent } from '../../../core/gas-dynamic-base/gas-dynamic-base.component';
import { GasColor } from '../../../core/colors/color.namespace';
import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasClickOutsideDirective } from '../../../utils/click-outside-directive/gas-click-outside.directive';
import { GasPopoverType } from '../gas-popup-type.interface';

interface IconInfo {
  name: GasIcon.Icons;
  iconColorClass: GasColor.IconColorClass;
}

const ICON_INFO: Record<GasPopoverType, IconInfo> = {
  [GasPopoverType.GeneralIcon]: {
    name: GasIcon.Actions.Info,
    iconColorClass: GasColor.IconColorClass.Brand,
  },
  [GasPopoverType.Warning]: {
    name: GasIcon.Notifications.Warning,
    iconColorClass: GasColor.IconColorClass.Warning,
  },
  [GasPopoverType.Error]: {
    name: GasIcon.Notifications.Error,
    iconColorClass: GasColor.IconColorClass.Error,
  },
  [GasPopoverType.Success]: {
    name: GasIcon.Notifications.Success,
    iconColorClass: GasColor.IconColorClass.Brand,
  },
  [GasPopoverType.General]: {
    name: GasIcon.Actions.Info,
    iconColorClass: GasColor.IconColorClass.Brand,
  },
  [GasPopoverType.Default]: {
    name: null,
    iconColorClass: GasColor.IconColorClass.Brand,
  },
};

@Component({
  selector: 'gas-popover',
  templateUrl: './gas-popover.component.html',
  styleUrls: ['./gas-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GasClickOutsideDirective,
  ],
})
export class GasPopoverComponent extends GasDynamicBaseComponent<void> {
  /** Тип элемента поповер */
  public set type(type: GasPopoverType | string) {
    this.iconName = ICON_INFO[type || GasPopoverType.Default].name;
    this.iconColorClass = ICON_INFO[type || GasPopoverType.Default].iconColorClass;
  }

  public maxPopupWidth: number;

  /** Отображает крестик для закрытия (элемент поповер) */
  public closeLabel = true;

  /** Текст для кнопки закрыть (элемент поповер) */
  public closeBtnText: string;

  /** Template для шапки */
  public headerTemplate: TemplateRef<ElementRef>;

  /** Template для футера */
  public footerTemplate: TemplateRef<ElementRef>;

  /** Template для body */
  public bodyTemplate: TemplateRef<ElementRef>;

  /** Имя иконки для отображения слева */
  public iconName: GasIcon.Icons;

  /** Цвет класса иконки */
  public iconColorClass: GasColor.IconColorClass;

  /** Заголовок */
  public label: string;

  /** Описание */
  public description: string;
}
